const initialState = {
    payoutPartnerData: [],
    loading: false,
    error: null,
};


const payoutPartnerDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PAYOUT_PARTNER_DATA_SUCCESS':
            return {
                ...state,
                payoutPartnerData: action.payload,
                loading: false,
                error: null,
            };
        case 'PAYOUT_PARTNER_DATA_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};


export default payoutPartnerDataReducer;